<template>
  <div class="education-learn">
    <div class="mx-4">
      <header class="d-flex my-2">
        <img src="https://prod-site-cdn.paykoko.com/bnpl-site-cms-dev/kokoIframeImages/MAINLogo-HD_H_21.01.05.png"
          alt="hero" class="main-logo" />
      </header>
      <div class="tab-container tab-outline-border p-3 ">
        <div class="d-flex justify-content-between align-items-center tab-outline-border px-2 mb-4">
          <h1 class="sub-header-color header my-1 font-weight-bold">All You Need To Know</h1>
          <img class="tab-header-img py-1" src="@/assets/images/loadingIcon.png" alt="load" />
        </div>

        <div class="d-flex flex-column flex-md-row align-items-start">
          <!-- Navigation Bar -->
          <div
            class="nav nav-pills me-3 flex-md-column flex-row justify-content-md-start justify-content-around navigation-bar"
            id="v-pills-tab" role="tablist" aria-orientation="vertical">
            <template v-for="(content, key) in tabHeader" :key="key">
              <button class="nav-link d-flex justify-content-between align-items-cente font-weight-bold"
                :class="{ active: activeTab === content.tabKey }" :id="content.tab" data-bs-toggle="pill"
                :data-bs-target="`#${content.tabKey}`" type="button" role="tab" :aria-controls="content.tabKey"
                :aria-selected="activeTab === content.tabKey" @click="changeTab(content.tabKey)">
                {{ content.buttonText }}
                <img class="nav-arrow" src="@/assets/images/rightArrow.svg" alt="rightArrow">
              </button>
            </template>
          </div>

          <!-- Tab Content -->
          <div class="tab-content w-100 mt-2" id="v-pills-tabContent">
            <div v-for="(panel, key) in tabContent" :key="key" class="tab-pane fade" :id="panel.id" role="tabpanel"
              :aria-labelledby="`${panel.id}-tab`" :class="{ 'active show': activeTab === panel.id }">
              <vue-collapsible-panel-group :style="{
                '--bg-color-header': 'transparent',
                '--border-color': 'transparent',
                '--bg-color-header-hover': 'transparent',
                '--bg-color-header-active': 'transparent',
                '--bg-color-body': 'transparent',
              }" class="">
                <vue-collapsible-panel class="mb-3 panel-group" v-for="(content, key) in panel.content" :key="key"
                  :expanded="false" @click="(t) => content.isExpanded = !content.isExpanded">
                  <template #title>
                    <div class="font-weight-600 title text-left">{{ content.title }}</div>
                  </template>
                  <template #content>
                    <p class="text-left panel-description ">{{ content.description }}</p>
                  </template>
                  <template #icon>
                    <img
                      :src="content.isExpanded ? require('@/assets/images/closeIcon.svg') : require('@/assets/images/plusIcon.svg')"
                      alt="close-open">
                  </template>
                </vue-collapsible-panel>
              </vue-collapsible-panel-group>
            </div>
          </div>
        </div>


      </div>

    </div>
  </div>

</template>

<script>
import {
  VueCollapsiblePanelGroup,
  VueCollapsiblePanel,
} from "@dafcoe/vue-collapsible-panel";
import { ref, watch, onMounted } from "vue";
import { useRoute, useRouter } from "vue-router";
export default {
  name: "PaymentSchemeLearn",
  components: { VueCollapsiblePanelGroup, VueCollapsiblePanel },
  setup() {
    const route = useRoute();
    const router = useRouter();
    const activeTab = ref(route.hash ? route.hash.substring(1) : "v-pills-general");

    const changeTab = (tabId) => {
      activeTab.value = tabId;
      router.replace({ hash: `#${tabId}` });
    };

    watch(
      () => route.hash,
      (newHash) => {
        activeTab.value = newHash ? newHash.substring(1) : "v-pills-general";
      }
    );
    onMounted(() => {
      activeTab.value = window.location.hash ? window.location.hash.substring(1) : "v-pills-general";
    });

    return {
      activeTab,
      changeTab,
    };
  },
  data() {
    const tabHeader = [
      { tab: "v-pills-general-tab", tabKey: "v-pills-general", buttonText: "General" },
      { tab: "v-pills-payments-tab", tabKey: "v-pills-payments", buttonText: "Payments" },
      { tab: "v-pills-services-tab", tabKey: "v-pills-services", buttonText: "Services" },
      { tab: "v-pills-refund-tab", tabKey: "v-pills-refund", buttonText: "Refund" },
      { tab: "v-pills-contact-tab", tabKey: "v-pills-contact", buttonText: "contact" }
    ]
    const tabContent = [
      {
        id: "v-pills-general", content: [
          { title: "What is Split in 6?", isExpanded: false, description: "Split in 6 is a flexible payment plan that allows you to split your purchase into six equal monthly instalments, with a small service fee applied to the total order value" },
          { title: "How can I check if I am eligible for Split in 6?", isExpanded: false, description: "If you are eligible, the Split in 6 option will appear at checkout. If it does not appear, you may not meet the eligibility requirements. You will also receive an email notification if you become eligible for Split in 6." },
          { title: "Is Split in 6 available for all merchants?", isExpanded: false, description: "Not all merchants may support Split in 6. The option will only be available if both you and the merchant are eligible." },
        ]
      },
      {
        id: "v-pills-payments", content: [
          { title: "Will my spending limit change based on the payment plan I choose?", isExpanded: false, description: "No, your total spending limit remains the same, but the maximum purchase amount may vary depending on the selected instalment plan. If the total order amount, including service fees, exceeds your limit, the Split in 6 option will be disabled." },
          { title: "What happens if I miss an instalment?", isExpanded: false, description: "A late payment fee will apply based on the order value. If you repeatedly miss payments, your ability to use Koko may be restricted." },
          { title: "Can I pay off my instalments early?", isExpanded: false, description: "Yes, you can settle your outstanding instalments early through the Koko app." },
          { title: "Can I change my payment method after selecting Split in 6?", isExpanded: false, description: "Yes, you can update your payment method for future instalments via the Koko app." }
        ]
      },
      {
        id: "v-pills-services", content: [
          { title: "Will I still be able to use Split in 3?", isExpanded: false, description: "Yes, Split in 3 remains available. You can choose between Split in 3 and Split in 6 at checkout, based on eligibility." },
          { title: "Can I switch from Split in 6 to Split in 3 after selecting it?", isExpanded: false, description: "No, once you confirm your payment plan at checkout, you cannot switch between instalment plans for that order." },
        ]
      },
      {
        id: "v-pills-refund", content: [
          { title: "What happens if I return a product?", isExpanded: false, description: "If you return the entire order, all paid instalments will be refunded, including the proportional service fee." },
          { title: "Is the service fee refundable if I cancel my order?", isExpanded: false, description: "If your refund is processed within the allowed period, the service fee will also be refunded." }
        ]
      },
      {
        id: "v-pills-contact", content: [
          {
            title: "How can I get support if I have issues with Split in 6?", isExpanded: false, description: "If you have any questions or need assistance, you can contact Koko’s customer support team or navigate to the Help Center through the app for more details."
          }
        ]
      }
    ]

    return {
      tabHeader, tabContent
    }
  },
  props: {}
};
</script>

<style scoped>
.education-learn {
  background-color: rgba(243, 238, 231, 1);
  min-height: 100vh;
}

.panel-group {
  border: 1px solid #021FA3;
  border-radius: 10px;
  max-width: 75%;
  margin: auto;
}

.panel-group .title {
  color: #636D79;
  margin-top: 10px;
  margin-bottom: 10px;
}

.panel-description {
  color: #A2A9B0
}

.education-learn .tab-container {
  background-color: rgba(255, 255, 255, 1);

}

.education-learn .tab-outline-border {
  border-radius: 5px;
  border: 1px solid #021FA3;
}

.education-learn .tab-outline-border .tab-header-img {
  width: 7.5%
}

.education-learn .sub-header-color {
  color: rgba(2, 31, 163, 1)
}

.education-learn .header {
  font-size: 1.5rem;
}

.navigation-bar {
  width: 150px
}

.nav-pills .nav-link.active {
  background-color: transparent;
  color: rgba(2, 31, 163, 1);
}

.nav-link {
  color: rgba(99, 109, 121, 1)
}

.nav-arrow {
  width: 20px;
  margin-left: 25px
}

.main-logo {
  width: 10%;
}

@media (max-width: 768px) {
  .main-logo {
    width: 15%;
  }

  .education-learn .tab-outline-border .tab-header-img {
    width: 12.5%
  }


  .panel-group {
    max-width: 100%;
  }

  .panel-group .title {
    font-size: 12px;
  }

  .panel-description {
    font-size: 11px;
  }


  .navigation-bar {
    width: 100%;
    margin-bottom: 15px;
  }

  .education-learn .header {
    font-size: 1rem;
  }

  .nav-arrow {
    visibility: hidden;
    width: 20px
  }

  #v-pills-tab {
    flex-wrap: nowrap;
    width: 100%;
    overflow-x: scroll;
  }

  #v-pills-tab button {
    flex: 1;
    min-width: 100px;
    text-align: center;
  }

}
</style>